import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const shopStyles = makeStyles((theme: Theme) => createStyles({
    title: {
        fontFamily: 'Cormorant Garamond',
        fontStyle: 'italic',
        fontWeight: 600,
        fontSize: '3.5rem',
        margin: '0.5rem 0 0.75rem 0',
        textAlign: 'center'
    },
    productCard: {
        margin: '2rem 0rem'
    },
    noProduct: {
        textAlign: 'center',
        marginTop: '1.5rem'
    },
    filtersContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'center',
        height: '130px',
        padding: '0 !important'
    },
    categoriesModal: {
        '& .MuiDialog-paper': {
            width: '400px'
        },
        '& .Mui-checked': {
            color: '#D32F2F' 
        }
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '40px',
        marginBottom: '30px',
        '& .MuiPaginationItem-textSecondary.Mui-selected': {
            backgroundColor: '#D32F2F'
        }
    }
}));

export default shopStyles;